import { createContext, type PropsWithChildren, useContext, useState } from "react";
import type { TimeRange } from "../utils/time";

export interface TimelineInteractionState {
  hoveredRange: TimeRange | null;
  hoveredTraceId: string | null;
}

export interface TimelineInteractionContextValue extends TimelineInteractionState {
  setHoveredRange: (range: TimeRange | null) => void;
  setHoveredTraceId: (traceId: string | null) => void;
}

const TimelineInteractionContext = createContext<TimelineInteractionContextValue | null>(null);

export function TimelineInteractionProvider({ children }: PropsWithChildren) {
  const [hoveredRange, setHoveredRange] = useState<TimeRange | null>(null);
  const [hoveredTraceId, setHoveredTraceId] = useState<string | null>(null);

  return (
    <TimelineInteractionContext.Provider
      value={{
        hoveredRange,
        hoveredTraceId,
        setHoveredRange,
        setHoveredTraceId,
      }}
    >
      {children}
    </TimelineInteractionContext.Provider>
  );
}

export function useTimelineInteraction(): TimelineInteractionContextValue {
  const ctx = useContext(TimelineInteractionContext);
  if (!ctx) {
    throw new Error("useTimelineInteraction must be used within a TimelineInteractionProvider");
  }
  return ctx;
}
